// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__s3QoV","footer":"Form_footer__1seVh"};